var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.196496 0.62749C0.470648 0.352475 0.915847 0.351776 1.19086 0.625929L5.88568 5.30609C5.94568 5.36581 6.0029 5.38118 6.0449 5.38112C6.08652 5.38105 6.14293 5.36578 6.202 5.30737L10.7852 0.615918C11.0566 0.338142 11.5018 0.332942 11.7795 0.604306C12.0573 0.87567 12.0625 1.32083 11.7912 1.59861L7.19984 6.29843C6.55126 6.94904 5.54355 6.95053 4.89294 6.30196L0.198057 1.62186C-0.0769581 1.3477 -0.0776571 0.902515 0.196496 0.62749Z",
    fill: "#FC686F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownRed);
export default __webpack_public_path__ + "static/media/arrow-down-red.92217d9130c8ef82f3cdc5a061af4c03.svg";
export { ForwardRef as ReactComponent };